/**
 * Color mode switcher for both desktop and mobile.
 */
export const initColorModeSwitcher = () => {

	if ( document.documentElement.classList.contains( 'fixed-theme-color' ) ) {

		return;

	}

	document.addEventListener( 'DOMContentLoaded', () => {

		const desktopSwitcher = document.querySelector( '.js-color-mode-switcher--desktop' );
		const mobileSwitcher = document.querySelector( '.js-color-mode-switcher--mobile' );

		if ( !desktopSwitcher && !mobileSwitcher ) {

			return;

		}

		applyTheme( getThemeColor() );
		document.documentElement.classList.add( 'js-theme-applied' );

		if ( desktopSwitcher ) {

			desktopSwitcher.addEventListener( 'change', onSwitcherChange );

		}

		if ( mobileSwitcher ) {

			mobileSwitcher.addEventListener( 'change', onSwitcherChange );

		}

		/**
		 * Apply Theme to both desktop and mobile switchers.
		 *
		 * @param {*} theme
		 */
		function applyTheme( theme ) {

			const currentTheme = document.documentElement.getAttribute( 'data-theme' );
			document.documentElement.setAttribute( 'data-theme', theme );

			if ( desktopSwitcher ) {

				desktopSwitcher.checked = ( theme === 'dark' );

			}

			if ( mobileSwitcher ) {

				mobileSwitcher.checked = ( theme === 'dark' );

			}

			if ( currentTheme === theme ) {

				return;

			}
			const themeChangeEvent = new CustomEvent( 'themeChange', {
				detail: { theme: theme }
			} );
			document.dispatchEvent( themeChangeEvent );

		}

		/**
		 * Watch for system theme changes.
		 */
		const prefersDarkScheme = window.matchMedia( '(prefers-color-scheme: dark)' );
		prefersDarkScheme.addEventListener( 'change', ( event ) => {

			if ( ! getSavedTheme() ) {

				applyTheme( event.matches ? 'dark' : 'light' );

			}

		} );

		/**
		 * Sync both switchers when one changes.
		 *
		 * @param {Event} event
		 */
		function onSwitcherChange( event ) {

			const newTheme = event.target.checked ? 'dark' : 'light';
			applyTheme( newTheme );
			localStorage.setItem( 'theme', newTheme );

		}

	} );

};

/**
 * Retrieves theme mode
 * from local storage
 *
 * @return {string} light|dark
 */
export const getThemeColor = () => {

	const validThemes = ['dark', 'light'];
	const savedTheme = getSavedTheme();

	if ( savedTheme && validThemes.includes( savedTheme ) ) {

		return savedTheme;

	}

	const prefersDarkMode = window.matchMedia( '(prefers-color-scheme: dark)' ).matches;
	return prefersDarkMode ? 'dark' : 'light';

}

/**
 * Retrieves theme color saved in local storage
 *
 * @return {string}
 */
export const getSavedTheme = () => {

	return localStorage.getItem( 'theme' );

}
